document.addEventListener('DOMContentLoaded', function() {
    waitForChatToLoad();
    setupLiveAssistanceButtons();
});

function waitForChatToLoad() {
    const chatElement = document.getElementById('ShopifyChat');
    if (chatElement && chatElement.shadowRoot && chatElement.getAttribute('is-open') !== null) {
        setupChatIconToggle();
        updateIconsBasedOnState();
    } else {
        setTimeout(waitForChatToLoad, 100); // Retry after a delay if the chat is not ready
    }
}

function setupChatIconToggle() {
    const chatElement = document.getElementById('ShopifyChat');
    const openIcon = document.querySelector('.header_chat_icon');
    const closeIcon = document.querySelector('.header_chat_icon_close');

    openIcon.addEventListener('click', function() {
        // Only attempt to open the chat if it is currently closed
        if (chatElement.getAttribute('is-open') === 'false') {
            const toggleButton = chatElement.shadowRoot.querySelector('.chat-toggle');
            toggleButton && toggleButton.click();
        }
    });

    closeIcon.addEventListener('click', function() {
        // Only attempt to close the chat if it is currently open
        if (chatElement.getAttribute('is-open') === 'true') {
            const closeButton = chatElement.shadowRoot.querySelector('.chat-app--close-button');
            closeButton && closeButton.click();
        }
    });

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'is-open') {
                const isOpen = chatElement.getAttribute('is-open') === 'true';
                updateIcons(isOpen);
            }
        });
    });

    observer.observe(chatElement, {
        attributes: true // Listen for attribute changes
    });
}

function updateIcons(isOpen) {
    const openIcon = document.querySelector('.header_chat_icon');
    const closeIcon = document.querySelector('.header_chat_icon_close');
    openIcon.classList.toggle('hidden', isOpen);
    closeIcon.classList.toggle('hidden', !isOpen);
}

function updateIconsBasedOnState() {
    const chatElement = document.getElementById('ShopifyChat');
    const isOpen = chatElement.getAttribute('is-open') === 'true';
    updateIcons(isOpen);
}

// Function to handle the Live Assistance button clicks (desktop and mobile)
function setupLiveAssistanceButtons() {
    const liveAssistanceButtons = document.querySelectorAll('#menu_live-assistance, #menu_live-assistance_mobile, #consultations_live-assistance, #product-popup-live-assistance, #faq-live-assistance, #search__recomendation_live__assistance, #get_personalized_guidance_live');

    liveAssistanceButtons.forEach(button => {
        button.addEventListener('click', function(event) {
            event.preventDefault();
            const chatElement = document.getElementById('ShopifyChat');
            if (chatElement && chatElement.getAttribute('is-open') === 'false') {
                const toggleButton = chatElement.shadowRoot.querySelector('.chat-toggle');
                if (toggleButton) {
                    toggleButton.click();
                    updateIcons(true); // Ensure close icon is shown
                }
            }
        });
    });
}
